import React, { useState } from 'react';
import ProCard from '@ant-design/pro-card';
import PropTypes from 'prop-types';
import fp from 'lodash/fp';
import { List, Descriptions } from 'antd';
import EndorsementDetail from './EndorsementDetail';
import { isEmpty } from 'utils';
import { DateDisplay } from 'components/layout';

const orderByEndorsementSequence = fp.orderBy('endorsementSequence', 'desc');

const EndorsementHistory = ({ data, initTab, defaultCollapsed }) => {
  const [tab, setTab] = useState(initTab.toString());
  const endorsements = orderByEndorsementSequence(data?.endorsements);
  if (isEmpty(data)) return null;
  return (
    <ProCard
      bordered
      collapsible
      title="Endorsement History"
      defaultCollapsed={defaultCollapsed}
    >
      <ProCard
        ghost
        tabs={{
          tabPosition: 'top',
          activeKey: tab,
          onChange: (key) => {
            setTab(key);
          },
        }}
      >
        {endorsements?.map((endorsement) => (
          <ProCard.TabPane
            key={endorsement.endorsementSequence}
            tab={`#${endorsement.endorsementSequence + 1}`}
          >
            <Descriptions column={1}>
              <Descriptions.Item label="Submission date">
                <DateDisplay date={endorsement.date} />
              </Descriptions.Item>
            </Descriptions>
            <List grid={{ gutter: 16, column: 1 }}>
              {endorsement.endorsementSteps?.map((step) => (
                <List.Item key={step.stepSequence}>
                  <EndorsementDetail key={step.stepSequence} step={step} />
                </List.Item>
              ))}
            </List>
          </ProCard.TabPane>
        ))}
      </ProCard>
    </ProCard>
  );
};

EndorsementHistory.defaultProps = {
  initTab: 0,
  data: {},
  defaultCollapsed: false,
};

EndorsementHistory.propTypes = {
  data: PropTypes.object.isRequired,
  initTab: PropTypes.number.isRequired,
  defaultCollapsed: PropTypes.bool,
};

export default EndorsementHistory;
